import { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from './input';

/**
 * OdometerInput - PTE-206
 * Handles prefix/suffix odometer entry.
 * Example: if reference value is 372620, prefix is 37, suffix is 2620.
 */
const OdometerInput = forwardRef((props, ref) => {
  const { 
    referenceValue, 
    onChange, 
    value: controlledValue,
    label,
    error,
    placeholder,
    ...rest 
  } = props;

  const [suffix, setSuffix] = useState('');
  const [prefix, setPrefix] = useState('');

  // When referenceValue or controlledValue changes, update prefix/suffix
  useEffect(() => {
    const val = controlledValue ? String(controlledValue) : (referenceValue ? String(referenceValue) : '');
    if (val.length > 4) {
      setPrefix(val.slice(0, -4));
      setSuffix(val.slice(-4));
    } else {
      setPrefix('');
      setSuffix(val);
    }
  }, [referenceValue, controlledValue]);

  const handleSuffixChange = (e) => {
    const newSuffix = e.target.value.replace(/\D/g, '').slice(0, 4);
    setSuffix(newSuffix);
    
    // Combine prefix + newSuffix and notify parent
    const fullValue = prefix + newSuffix;
    if (onChange) {
      onChange(fullValue);
    }
  };

  return (
    <Input
      label={label}
      ref={ref}
      value={suffix}
      onChange={handleSuffixChange}
      error={error}
      placeholder={placeholder || "Saisir les 4 derniers chiffres"}
      prefix={prefix ? (
        <span className="text-gray-400 font-bold bg-gray-100 dark:bg-dark-600 px-2 py-0.5 rounded border border-gray-200 dark:border-dark-500 mr-1 select-none">
          {prefix}
        </span>
      ) : null}
      classNames={{
        prefix: "w-auto px-1 ltr:left-1",
        input: prefix ? "ltr:pl-16 font-mono tracking-widest text-lg" : "font-mono tracking-widest text-lg"
      }}
      {...rest}
    />
  );
});

OdometerInput.displayName = 'OdometerInput';

OdometerInput.propTypes = {
  referenceValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.node,
  error: PropTypes.any,
  placeholder: PropTypes.string
};

export { OdometerInput };
